import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiEyeOff } from "react-icons/fi";

export default function ChangePasswordModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Current Password *</Form.Label>
          <div className="input-icon">
            <Form.Control type="password" />
            <FiEyeOff />
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>New Password *</Form.Label>
          <div className="input-icon">
            <Form.Control type="password" />
            <FiEyeOff />
          </div>
        </Form.Group>

        <Form.Group>
          <Form.Label>Confirm New Password *</Form.Label>
          <div className="input-icon">
            <Form.Control type="password" />
            <FiEyeOff />
          </div>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button className="orange-btn">Save</Button>
      </Modal.Footer>
    </Modal>
  );
}